export const projects = [
  {
    id: 1,
    title: "DT Money",
    description: "React application that aims to manage personal finances.",
    github_url: "https://github.com/darlysson/01-dtmoney",
    url: "https://01-dtmoney.pages.dev/",
    techs: ["React", "Typescript", "Styled Components"],
  },
  {
    id: 2,
    title: "Insurance Landing Page",
    description: "Landing page created to try Tailwind CSS.",
    github_url: "https://github.com/darlysson/insurance",
    url: "https://darlysson.github.io/insurance/",
    techs: ["HTML", "Tailwind"],
  },
  {
    id: 3,
    title: "FAQs",
    description:
      "Application to simulate a FAQ section, composed by show & hide description.",
    github_url: "https://github.com/darlysson/faqs",
    url: "https://faqs.pages.dev/",
    techs: ["React", "Sass"],
  },
  {
    id: 4,
    title: "Tours",
    description:
      "Application created to manipulated some of the basics aspects of React Development.",
    github_url: "https://github.com/darlysson/tours",
    url: "https://tours.pages.dev/",
    techs: ["React", "Sass"],
  },
  {
    id: 5,
    title: "Reviews",
    description:
      "Application created to manipulated some of the basics aspects of React Development.",
    github_url: "https://github.com/darlysson/reviews",
    url: "https://reviews-qq9i.pages.dev/",
    techs: ["React", "Sass"],
  },
]
